import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { reserveRoutes } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput, RadioInput } from '../../components/common/components'
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';





export default function SchdType() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const [schdId, setSchdId] = useState("AH")

    const dispatch = useDispatch()

    let history = useHistory();

    const handleNextClick = () => {
        window.location.href = `./second_step?schd_type=${schdId}&src=first_step`
        // history.push(`/second_step?schd_type=${schdId}`)
    }

    if (option.schd_type.length === 0) {
        return <div>loading...</div>
    }

    let schdTypeData = _.find(option.schd_type, (o) => {
        return o.value === schdId
    })

    const handleSchdIdChange = (field, val) => {
        // console.log(field, val);
        setSchdId(val)
    }


    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center" style={{ fontSize: "20px" }}>
                {reserveRoutes[idx].name}
            </Typography>
            <p style={{ paddingLeft: "30px", fontSize: "20px" }}>[免費] 國健署癌症篩檢、成人預防保健</p>

            <p style={{ paddingLeft: "30px", letterSpacing: 0, margin: 0, lineHeight: "1.5" }}>
                免費篩檢報名資格
                <br /><br />
                {/* ※胃癌篩檢(114年試辦): 45歲至 74歲民眾，終身接受 1次。114年本院試辦名額為80人，額滿後系統將自動關閉預約功能。<br/> */}
                1.乳癌：40-74歲女性，每2年1次乳房攝影檢查。<br/>
                2.肺癌：有肺癌家族史或重度吸菸史者提供LDCT低劑量電腦斷層檢查，每2年1次。<br/>
                ＞＞ 肺篩資格請詳閱:  <a href='https://www.kfsyscc.org/knowledge_media_detail/free-ldct' target='_blank'>https://www.kfsyscc.org/knowledge_media_detail/free-ldct</a><br/>
                3.大腸癌：符合下列其中一項資格，每2年1次糞便潛血檢查。<br/>
                * 45至74歲民眾<br/>
                *大腸癌家族史：40至44歲，且其父母、子女或兄弟姊妹曾患有大腸癌之民眾。 (請攜帶該親屬之姓名、身分證號碼、出生年月日，以供報名填寫)。<br/>
                4.胃幽門螺旋桿菌篩檢：45-74歲，終身一次，未曾參與國健署碳13尿素吹氣法或113及114年糞便抗原試辦之民眾。<br/>
                5.口腔癌：30歲以上有嚼檳榔(含已戒)或吸菸者、18歲以上有嚼檳榔(含已戒)原住民，每2年1次口腔黏膜檢查。<br/>
                6.子宮頸癌：25-29歲女性每3年1次； 30歲以上女性每年1次抹片檢查(本院採用拋棄式衛材，需酌收衛材費用)。<br/>
                7.成人預防保健：30-39歲每5年1次；40-64歲每3年1次；65歲以上每年1次。<br/>
                &nbsp;&nbsp;7-1. B、C肝炎篩檢：45歲至79歲民眾或40歲至79歲原住民，終身1次。<br/>
                8.戒菸門診：此為健保門診，因此將收取掛號費及部分負擔費用。<br/>
                
                
                <br />
                
            </p>
            <p style={{ paddingLeft: "30px", fontSize: "20px" }}>[自費]</p>

            <p style={{ paddingLeft: "30px", letterSpacing: 0, margin: 0, lineHeight: "1.5" }}>
            <a href='https://www.kfsyscc.org/guide_cancer_screening/self-pay-cancer-screening' rel="noreferrer" target={"_blank"}>了解更多資訊</a><br/><br/>
            1.胃幽門螺旋桿菌篩檢：幽門桿菌糞便抗原檢測，年滿 18歲，費用450元<br/>
            2.肺癌篩檢：肺部低劑量電腦斷層檢查 (LDCT)，年滿 25歲，費用 6,000元

            </p>
            <div style={{ marginLeft: "30px" }}>
                {/* <Table>
                <TableHead>
                    <TableRow>                       
                        <TableCell colSpan={2} align="center">服務時間</TableCell>	 
                        <TableCell align="center">報名地點</TableCell>	 
                        <TableCell align="center">肺癌</TableCell>	 
                        <TableCell align="center">乳癌</TableCell>	 
                        <TableCell align="center">大腸癌</TableCell>	 
                        <TableCell align="center">口腔癌</TableCell>	 
                        <TableCell align="center">子宮頸癌</TableCell>	
                        <TableCell align="center">成人預防保健</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell rowSpan={3} align="center">周一至週五</TableCell>
                        <TableCell align="center">0900-1600</TableCell>
                        <TableCell align="center">B1中央櫃台</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell rowSpan={3} align="center">抹片檢查，請掛本院婦科門診</TableCell>
                        <TableCell align="center">V</TableCell>
                    </TableRow> 
                    <TableRow>
                        <TableCell align="center">0900-1200</TableCell>
                        <TableCell align="center">B1婦女門診</TableCell>
                        <TableCell></TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow> 
                    <TableRow>
                        <TableCell align="center">1300-1600</TableCell>
                        <TableCell align="center">3F大健康中心</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                    </TableRow> 
                </TableBody>
            </Table> */}
            </div>







            {option.loading ?
                <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.3)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress size={200} />
                </div> : null}
        </Paper>
        {option.loading ? null : <>
            {!schdTypeData || schdTypeData.isActive === "N" ? null : <Button
                variant="contained"
                color="primary"
                style={{ margin: "30px auto" }}
                onClick={() => { handleNextClick() }}
            >
                下一步
            </Button>}
        </>
        }
    </Box>
}